import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { fetchOrganizationDevices, unenrollDevice } from "js/Api/index";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import deviceProfile from "images/device.png";
import { Pagination, Stack } from "@mui/material";
import UserSetting from "js/UserBoard/ManageDevice/UserSettings/userSetting";

function ManageDevices({ settingsFrom, selectedOrg, userInfo, resetFlag, initialSelectedUser, initialTab,
}) {
    const [selectedTab, setSelectedTab] = useState("All Devices");
    const [selectedUser, setSelectedUser] = useState(null);
    const [cwusers, setCwUsers] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteDevice, setDeleteDevice] = useState(null);
    const [isFamilyorg, setisFamilyorg] = useState(selectedOrg?.orgType === "family" ? true : false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tabFromUrl = queryParams.get("tab");

    const [currentPage, setCurrentPage] = useState(1); // Current page number
    const [isLoading, setIsLoading] = useState(true); // Loading state
    const itemsPerPage = 100; // Number of items per page

    useEffect(() => {
        if (initialSelectedUser && !selectedUser) {
            setSelectedUser(initialSelectedUser);
        }
    }, [initialSelectedUser]);

    useEffect(() => {
        if (selectedOrg) {
            loadOrganizationDevices(selectedOrg);
            setisFamilyorg(selectedOrg?.orgType === "family" ? true : false);
        }
    }, [selectedOrg]);

    useEffect(() => {
        setSelectedUser(null);
    }, [resetFlag]);

    const loadOrganizationDevices = async (org) => {
        if (!org) return;

        await fetchOrganizationDevices(org.code)
            .then((res) => {
                if (res.success) {
                    setCwUsers(res.data.sort((a, b) => {
                        const aName = a.name?.trim() || "";
                        const bName = b.name?.trim() || "";
                        return aName.localeCompare(bName);
                    }));
                }
            })
            .catch((err) => {
                console.log("Failed to fetch organization devices:", err);
            })
            .finally(() => setIsLoading(false));
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const getCurrentPageItems = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return filteredCwUsers.slice(startIndex, startIndex + itemsPerPage);
    };

    const handleRowClick = (user) => {
        setSelectedUser(user);
    };

    const handleBackClick = () => {
        setSelectedUser(null);
    };

    const handleDeleteDeviceCancel = () => {
        setShowDeleteModal(false);
        setDeleteDevice(null);
    };

    const handleUnenrollClick = async () => {
        const result = await unenrollDevice(deleteDevice.id);

        if (result.success) {
            toast.success(result.message);
            loadOrganizationDevices(selectedOrg);
        } else {
            toast.error(result.error);
        }

        setShowDeleteModal(false);
        setDeleteDevice(null);
    };

    const handleSearchInputChange = (e) => {
        setCurrentPage(1);
        setSearchQuery(e.target.value);
    };

    const filteredCwUsers = cwusers.filter(
        (user) =>
            (user.name &&
                user.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (user?.konnektDeviceId &&
                user?.konnektDeviceId?.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (user.serialNo &&
                user.serialNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (user.policyName &&
                user.policyName.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (user.orgEnrollDate &&
                new Date(user.orgEnrollDate)
                    .toLocaleDateString("en-GB")
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase()))
    );

    return (
        <div className="midde_cont">
            <div className="container-fluid" style={{ paddingLeft: "0", paddingRight: "0" }} >
                <div className="row column_title">
                    <div className="col-md-12">
                        <div className="page_title" style={{ display: "flex", alignItems: "center" }} >
                            {selectedUser ? (
                                <ArrowBackRoundedIcon onClick={handleBackClick} sx={{ fontSize: "2rem", color: "black", marginRight: "10px", cursor: "pointer", }} />
                            ) : null}
                            <h2 style={{ flex: "1" }}>Manage Devices</h2>
                        </div>
                    </div>
                </div>

                {/*<div className="loader"></div>*/}

                {selectedUser ? (
                    <UserSetting user={selectedUser} userInfo={userInfo} onBackClick={handleBackClick} settingsFrom={settingsFrom} selectedOrg={selectedOrg}
                        fetchCwUsers={() => loadOrganizationDevices(selectedOrg)} setSelectedUser={setSelectedUser} initialTab={tabFromUrl} />
                ) : (
                    <>
                        <div className="white_shd full margin_bottom_30">
                            <div className="full inner_elements">
                                <div class="padding_infor_info" id="nav-tabContent">
                                    <div className={`tab-pane fade ${selectedTab === "All Devices" ? "show active" : ""}`} id="nav-all-devices" role="tabpanel" aria-labelledby="nav-all-devices-tab" >
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="table-wrap">
                                                    <div className="form-group">
                                                        <input type="text" className="form-control w-50 search-input" placeholder="Search devices..." value={searchQuery} onChange={handleSearchInputChange} />
                                                    </div>
                                                    {isLoading ?
                                                        <div className="loader"></div>
                                                        :
                                                        <>
                                                            <table className="table table-hover device-table">
                                                                <thead>
                                                                    <tr key="headers">
                                                                        {selectedOrg?.code === "konnekt" ? (
                                                                            <>
                                                                                <th key="Name">Konnekt User</th>
                                                                                <th key="Name">Videophone Profile Name</th>
                                                                                <th>CareWindow Device ID</th>
                                                                                <th key="Date">Date Enrolled</th>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <th key="Name">CareWindow User</th>
                                                                                <th key="sr" width="15%">Device S/N</th>
                                                                                <th key="Date" width="15%">Date Enrolled</th>
                                                                                <th key='Version' width="10%">App Version</th>
                                                                                {!isFamilyorg && <th key="Poicy" width="15%">Device Group</th>}
                                                                            </>
                                                                        )}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {getCurrentPageItems().map((user) => (
                                                                        <tr key={user.id} onClick={() => handleRowClick(user)} >
                                                                            <td>
                                                                                {user.profilePicture ? (
                                                                                    <img className="user-photo" src={`data:image/png;base64, ${user.profilePicture}`} alt={user.name} />
                                                                                ) : (
                                                                                    <img className="user-photo" src={deviceProfile} alt="Default profile" />
                                                                                )}
                                                                                {user.name}
                                                                            </td>
                                                                            {selectedOrg?.code === "konnekt" ?
                                                                                <>
                                                                                    <td style={{ verticalAlign: "middle" }}>
                                                                                        {user.konnektDeviceId}
                                                                                    </td>
                                                                                    <td style={{ verticalAlign: "middle" }}>
                                                                                        {user.id}
                                                                                    </td>
                                                                                    <td style={{ verticalAlign: "middle" }}>
                                                                                        {new Date(user.orgEnrollDate).toLocaleDateString("en-GB")}
                                                                                    </td>
                                                                                </>

                                                                                :
                                                                                <>
                                                                                    <td style={{ verticalAlign: "middle" }}>
                                                                                        {user.serialNo}
                                                                                    </td>
                                                                                    <td style={{ verticalAlign: "middle" }}>
                                                                                        {new Date(user.orgEnrollDate).toLocaleDateString("en-GB")}
                                                                                    </td>


                                                                                    <td style={{ verticalAlign: "middle" }}>
                                                                                        {user.apP_Version ? user.apP_Version : "(No Data)"}
                                                                                    </td>
                                                                                    {!isFamilyorg &&
                                                                                        <td style={{ verticalAlign: "middle" }}>
                                                                                            {user.policyName ? user.policyName : "(none)"}
                                                                                        </td>
                                                                                    }
                                                                                </>
                                                                            }
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </>
                                                    }

                                                    {filteredCwUsers.length > itemsPerPage && (
                                                        <Stack spacing={2} alignItems="flex-end" sx={{ mt: 2, pr: 2 }} >
                                                            <Pagination count={Math.ceil(filteredCwUsers.length / itemsPerPage)}
                                                                page={currentPage} onChange={(event, value) => handlePageChange(value)} color="primary" size="small" />
                                                        </Stack>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
                }

                {
                    showDeleteModal && (
                        <div className="modal fade show" style={{ display: "block" }} aria-modal="true" role="dialog" >
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title">Delete Device</h1>
                                        <button type="button" className="close-button" onClick={handleDeleteDeviceCancel} aria-label="Close" >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <p>
                                            Are you sure you want to unenroll{" "}
                                            <strong>{deleteDevice.name}</strong>?{" "}
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={handleDeleteDeviceCancel} > Cancel{" "} </button>
                                        <button type="button" className="btn btn-danger" onClick={handleUnenrollClick} > Delete{" "} </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }

            </div >
        </div >
    );
}

export default ManageDevices;
